module.exports = __webpack_public_path__ + "components/MapControl/svg/Hotel.svg?ac8a0247";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Hotel.svg
// module id = 1820
// module chunks = 0